import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /subscription-periods/{id}/milestone-meta-data
 * @returns {AxiosPromise<any>}
 */
export const GET_SUB_PERIOD_MILESTONE_METADATA = id => request.get(`/subscription-periods/${id}/milestone-meta-data`)

/**
 * @description GET /subscription-periods/{id}/milestones/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUB_PERIOD_MILESTONE = (subId, milId) =>
  request.get(`/subscription-periods/${subId}/milestones/${milId}`)
